export const SignupActions = {
    SHOW_LOGIN_MODAL: '@@signup/SHOW_LOGIN_MODAL',
    CLOSE_LOGIN_MODAL: '@@signup/CLOSE_LOGIN_MODAL',
    SETUP_CSS_TRANSITION_TO_NEXT_PAGE:
        '@@signup/SETUP_CSS_TRANSITION_TO_NEXT_PAGE',
    SETUP_CSS_TRANSITION_TO_PREV_PAGE:
        '@@signup/SETUP_CSS_TRANSITION_TO_PREV_PAGE',
};

export const showLoginModal = () => ({
    type: SignupActions.SHOW_LOGIN_MODAL,
});

export const setupCssTransitionToPrevPage = () => ({
    type: SignupActions.SETUP_CSS_TRANSITION_TO_PREV_PAGE,
});

export const setupCssTransitionToNextPage = () => ({
    type: SignupActions.SETUP_CSS_TRANSITION_TO_NEXT_PAGE,
});

export const closeLoginModal = () => ({
    type: SignupActions.CLOSE_LOGIN_MODAL,
});
